import type { SupabaseClient } from "@supabase/supabase-js"

import { AuthenticationError } from "./errors"
import { type AuthUser, mapSupabaseClaimsToAuthUser } from "./utils"

export type RequireUserResult =
  | {
      error: null
      user: AuthUser
    }
  | {
      error: AuthenticationError
      user: null
    }

/**
 * @name requireUser
 * @description Require a session to be present in the request
 * @param supabase
 */
export async function requireUser(
  supabase: SupabaseClient,
): Promise<RequireUserResult> {
  const { data, error } = await supabase.auth.getClaims()

  if (!data?.claims || error) {
    return {
      user: null,
      error: new AuthenticationError(),
    }
  }

  return {
    error: null,
    user: mapSupabaseClaimsToAuthUser(data.claims),
  }
}
